import { Injectable } from '@angular/core';
import { LoggingDatabaseRepository } from '../database';
import { LogLevel } from '../models';
import { ILoggingPublisher } from './logging-publisher.interface';

@Injectable()
export class RxdbLogLoggingPublisher implements ILoggingPublisher {
	public constructor(private logsRepository: LoggingDatabaseRepository) {}

	public async log(title: string, body: string, level: LogLevel): Promise<void> {
		switch (level) {
			case LogLevel.Error:
				this.logsRepository.insert({
					title,
					logLevel: 'Error',
					body,
					dateTime: new Date().toString()
				});
				break;
			case LogLevel.Info:
				this.logsRepository.insert({
					title,
					logLevel: 'Info',
					body,
					dateTime: new Date().toString()
				});
				break;
			case LogLevel.Warning:
				this.logsRepository.insert({
					title,
					logLevel: 'Warning',
					body,
					dateTime: new Date().toString()
				});
				break;
			default:
				break;
		}
	}
}
